import { getEnvFlag } from './getEnvVar';

export function isScimEnabled() {
    const isOpsPortal = window.location.hostname.startsWith('opsportal.');

    if (isOpsPortal) {
        return true;
    }

    return getEnvFlag('ENABLE_SCIM_UI', true);
}
